// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"7599a3ce","139":"487df83f","319":"bd446360","580":"0eb145c7","682":"c54468b6","981":"2946b11a"}[chunkId] + ".chunk.css";
};